(() => {
  angular.module('app').component('hostHospitalizationExclusionsClauseNoteComponent', {
    templateUrl: require('./clauseNote.component.html'),
    controller: ClausNoteComponentController,
    controllerAs: 'vm',
    bindings: {
      exclusions: '<',
      exclusionType: '<',
      characterLimit: '<',
      isExclusion: '<',
      isEditing: '<',
      add: '&',
      remove: '&',
    },
  });

  ClausNoteComponentController.$inject = [
    '$document',
    'abp.services.app.hospitalizationExclusion',
    'moment',
  ];

  function ClausNoteComponentController($document, hospitalizationExclusionSvc, moment) {
    const vm = this;
    vm.loading = 0;
    vm.today = moment().startOf('day');
    vm.keywords = [];

    vm.$onInit = init;
    vm.$onChanges = onChanges;
    vm.addClause = addClause;
    vm.deleteClause = deleteClause;

    function init() {
      _.each(vm.exclusions, (p) => {
        p.isNewRecord = p.id < 0;
      });

      getExclusionNoteSuggestionHash();
    }

    function getExclusionNoteSuggestionHash() {
      vm.loading += 1;
      hospitalizationExclusionSvc
        .getExclusionNoteSuggestionHash({})
        .success((data) => {
          vm.keywords = data;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    $document.ready(() => {
      _.each(vm.exclusions, (p) => {
        $(`#content-${p.type}-${p.id}`).summernote('code', p.clause);
        if (!vm.isEditing) {
          $(`#content-${p.type}-${p.id}`).summernote('disable');
        }
      });
    });

    function onChanges() {
      _.each(vm.exclusions, (p) => {
        if (vm.isEditing) {
          $(`#content-${p.type}-${p.id}`).summernote('enable');
        } else {
          $(`#content-${p.type}-${p.id}`).summernote('disable');
        }
      });
    }

    function addClause(exclusionType) {
      vm.add({ exclusionType });
    }

    function deleteClause(id, exclusionType) {
      vm.remove({ exclusionId: id, exclusionType });
    }
  }
})();
